import DispatchConstants from '../../constants/DispatchConstants';

import PropertyOverview from '../../model/PropertyOverview';

const initState = () => PropertyOverview();

const currentProperty = (state = initState(), action = {}) => {
  const { type, payload } = action;

  if (type === DispatchConstants.UPDATE_PROPERTY_OVERVIEW) {
    return Object.assign({}, state, payload);
  }

  return state;
};

export default currentProperty;
